import React from "react";
import { Route, Switch } from "react-router-dom";

import { SIP_DEVICES } from "constants/routes";

import { Admins } from "constants/userRoles";

import SipDeviceDetail from "views/SipDevices/SipDeviceDetail";
import SipDeviceEdit from "views/SipDevices/SipDeviceEdit";

const SipDevice = () => (
  <Switch>
    <Route path={SIP_DEVICES.EDIT} component={Admins(SipDeviceEdit)} />
    <Route exact path={SIP_DEVICES.SHOW} component={SipDeviceDetail} />
  </Switch>
);

export default SipDevice;
